export default {
  sm: `
  Spirit of
  "Janggyeonggak" that
  has been protecting
  Tripitaka Koreana
  `,
  lg: `
  Spirit of "Janggyeonggak"
  that has been protecting
  Tripitaka Koreana
  `
};
